import React, { useContext, useEffect } from 'react';

import SiteSeeContext from './SiteSeeContext';

import { ReactComponent as ZoomZoneIcon } from '../../SVGAssets/zoom-zone.svg';

const SiteSeeZoomZonesGuide = () => {
  const { siteSeeName, actionWord, siteSeeGuideMode } = useContext( SiteSeeContext );
  const isCoached = siteSeeGuideMode === 'tour';
  const mapShell = document?.querySelector( '.mapShell' ) ? document.querySelector( '.mapShell' ) : null;
  const mapShellClassList = mapShell ? mapShell.classList : null;

  useEffect( () => {
    if ( !mapShell ) return;
    if ( isCoached ) {
      mapShellClassList?.add( 'mapShell--dimForZoomZone' );
    } else {
      mapShellClassList?.remove( 'mapShell--dimForZoomZone' );
    }
    return () => {
      mapShellClassList?.remove( 'mapShell--dimForZoomZone' );
    };
  }, [ isCoached, mapShellClassList ] );

  return (
    <>
      { actionWord }
      {' '}
      any
      {' '}
      {siteSeeName}
      {' '}
      marker with an

      <span className="siteSeeGuide__icon siteSeeGuide__icon--inline">
        <ZoomZoneIcon />
      </span>

      icon to zoom in and explore residences and amenities in a particular community area.
    </>
  );
};

export default SiteSeeZoomZonesGuide;
